// DEPENDENCIES: slick.min.js

(function ($) {
  $.fn.lmGallery = function(options) {

    // check is dom element is defined
    if (!this.length) {
      return false;
    }

    // Default settings are set here
    var settings = $.extend({
      mainTrack: '.gallery__track',
      previewTrack: '.gallery__preview-track',
      tag: '.gallery__count',
      caption: '.gallery__item-caption',
      prevButton: '.gallery__prev',
      nextButton: '.gallery__next',
      expandButton: '.gallery__expand',
      closeButton: '.gallery__close',
      singleClass: 'gallery-single',
      itemClass: '.gallery__item',
      itemAdId: '#slider-ad',
      breakpoint: 980,
      thumbnailSlidesToShowDefault: 6,
      thumbnailSlidesToShowDefaultGrid: 30,
      gridClass: '.gallery__preview-track--grid',
      galleryThumbnail: '.gallery__thumbnail',
      currentSlideNum: 0,
      document: $(document)
    }, options);

    // These are all the methods available for the plugin
    var methods = {};

    const  SLIDE_DIRECTION = {
        NEXT: 1,
        PREVIOUS: -1
      };

    // Variables
    var $window,
      resizeTimeout = null,
      $mainTrack,
      $previewTrack,
      $tag,
      $caption,
      $expandButton,
      initSlick,
      inExpandMode = false,
      inMobileMode,
      $closeButton,
      $prevButton,
      $nextButton,
      $sliderItem,
      $sliderAd,
      //currentSlideNum = 0,
      inGridMode,
      timeStampLast,
      sameEvent,
      prevSlideIdx = 0,
      resetAd = false,
      viewedAd = false,
      slickTrackLeft = Number.MIN_VALUE,
      slideDirection = SLIDE_DIRECTION.NEXT,
      $galleryThumbnail,
      initialTargetIndex = null;

    methods.setCurrentSettings = function($context) {
      var currentSettings = $context.data();
      if (!$.isEmptyObject(currentSettings)) {
        $context.data($.extend({}, settings, currentSettings));
      } else {
        $context.data(settings);
      }
      // Initialize item
      $context.data('initialized', true);
    }

    methods.initSlick = function($context) {
      var width = $(window).width();
      var height = $(window).height();

      inGridMode =  $context.find(settings.gridClass).length;

      if (width < settings.breakpoint) {
        if (!inGridMode) {
          $context.removeClass('gallery--expand');
        }
        $context.removeClass('gallery--portrait');
        inExpandMode = false;
        inMobileMode = true;

      } else {
        inMobileMode = false;
        if (height > width && inExpandMode) {
          $context.addClass('gallery--portrait');
          $context.removeClass('gallery--portrait');
        }
      }

      if (initSlick) {
        methods.restartSlick($context);
      } else {
        methods.startSlick($context);
      }

      methods.modifyGrid($context);
    }

    methods.setCaption = function(index) {
      var i;
      if (index) {
        i = (index-1);
      } else {
        i = index;
      }
      let _caption = $($mainTrack[0].slick.$slides[i]).data('caption');
      $caption.html(_caption);
    }

    methods.setOgMeta = function() {

      var newOGImageUrl = $('.gallery__item.slick-slide.slick-current.slick-active').find('img').attr('src');

      let _i = $($('.gallery__item.slick-slide.slick-current.slick-active')).data('slick-index')
      let _itemIdentifier = $($mainTrack[0].slick.$slides[_i]).data('content-identifier');
      //let _caption = $($mainTrack[0].slick.$slides[i]).data('caption');
      let _caption = $($('.gallery__item.slick-slide.slick-current.slick-active')).data('caption')
      let _targetUrl = window.location.origin + window.location.pathname;

      if(undefined != _itemIdentifier && _itemIdentifier.length > 0) {
        _itemIdentifier = '?feature=' + _itemIdentifier;
        _targetUrl = window.location.origin + window.location.pathname + _itemIdentifier;
        history.pushState(_caption, null, _targetUrl);
      }

      $('meta[property="og\\:url"]').attr("content", _targetUrl);

      $("meta[property='og\\:image']").attr("content", newOGImageUrl);
      $("meta[property='og\\:image']").attr("content", newOGImageUrl);
      $("meta[property='og\\:image\\:url']").attr("content", newOGImageUrl);
      $("meta[property='og\\:image\\:secure_url']").attr("content", newOGImageUrl);
      $("meta[property='og\\:image\\:secure_url']").attr("content", newOGImageUrl);
      $("meta[property='og\\:image\\:type']").attr("content", 'image/jpeg');

      if(0 ==  $("meta[property='og\\:image\\:alt']").length) {
        $('<meta property="og:image:alt" content="' + _caption + '">').insertAfter('meta[property="og\\:image\\:url"]');
      } else {
       $('meta[property="og\\:image\\:alt"]').attr('content', _caption);
      }

      // twitter meta
      $("meta[name='twitter\\:site']").attr("content", _caption);
      $("meta[name='twitter\\:image']").attr("content", newOGImageUrl);
      $("meta[name='twitter\\:image\\:type']").attr("content", 'image/jpeg');

      if(0 ==  $("meta[name='twitter\\:image\\:alt']").length) {
        $('<meta name="twitter:image:alt" content="' + _caption + '">').insertAfter("meta[name='twitter\\:image']");
      } else {
       $("meta[name='twitter\\:image\\:alt']").attr("content", _caption);
      }
    }

    methods.restartSlick = function($context) {
      $mainTrack.slick('unslick');
      $previewTrack.slick('unslick');
      methods.startSlick($context);
    }

    methods.startSlick = function($context) {
      initSlick = true;

      methods.initGrid($context);

      var thumbnail_options = {
        asNavFor: settings.mainTrack,
        centerMode: false,
        dots: false,
        focusOnSelect: true,
        nextArrow: settings.nextButton,
        accessibility: true,
        variableWidth: false,
        onAfterChange: function(slider,i) {
          methods.setCaption(i);
        },
        prevArrow: settings.prevButton,
        slidesToScroll: 1
      };

      thumbnail_options.infinite = true;
      if (inExpandMode && !inGridMode) {

        thumbnail_options.responsive = [{
          breakpoint: 2080,
          settings: {
            slidesToShow: 11
          }
        },{
          breakpoint: 1880,
          settings: {
            slidesToShow: 10
          }
        },{
          breakpoint: 1680,
          settings: {
            slidesToShow: 9
          }
        },{
          breakpoint: 1480,
          settings: {
            slidesToShow: 8
          }
        },{
          breakpoint: 1280,
          settings: {
            slidesToShow: 7
          }
        },{
          breakpoint: 980,
          settings: {
            slidesToShow: 6
          }
        },{
          breakpoint: 680,
          settings: {
            slidesToShow: 5
          }
        },{
          breakpoint: 580,
          settings: {
            slidesToShow: 4
          }
        },{
          breakpoint: 460,
          settings: {
            slidesToShow: 3
          }
        },{
          breakpoint: 320,
          settings: {
            slidesToShow: 2
          }
        }];
        thumbnail_options.slidesToShow = 12;
        thumbnail_options.centerMode = false;
      } else if (inExpandMode && inGridMode) {

      thumbnail_options.variableWidth = true;
        thumbnail_options.responsive = [{
          breakpoint: 2080,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 1880,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 1680,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 1480,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 1280,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 980,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 680,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 580,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 460,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 320,
          settings: {
            slidesToShow: 30
          }
        }];
        thumbnail_options.slidesToShow = 30;
        thumbnail_options.centerMode = false;

      } else if (inMobileMode && !inGridMode ) {

        thumbnail_options.responsive = [{
          breakpoint: 980,
          settings: {
            slidesToShow: 6
          }
        },{
          breakpoint: 680,
          settings: {
            slidesToShow: 5
          }
        },{
          breakpoint: 580,
          settings: {
            slidesToShow: 4
          }
        },{
          breakpoint: 460,
          settings: {
            slidesToShow: 3
          }
        },{
          breakpoint: 320,
          settings: {
            slidesToShow: 2
          }
        }];
        thumbnail_options.centerMode = false;

      } else if (inGridMode ) {

        thumbnail_options.slidesToShow = 30;
        thumbnail_options.centerMode = false;
        thumbnail_options.variableWidth = true;
        thumbnail_options.responsive = [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 30
          }
        },{
          breakpoint: 1000,
          settings: {
            slidesToShow: 30
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 30
          }
        }];

      } else {

        thumbnail_options.slidesToShow = settings.thumbnailSlidesToShowDefault;
        thumbnail_options.centerMode = false;
        thumbnail_options.responsive = [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },{
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        }];
      }



      $mainTrack.slick({
        arrows: true,
        asNavFor: settings.previewTrack,
        fade: false,
        lazyLoad: 'ondemand',
        initialSlide: 0,
        nextArrow: settings.nextButton,
        prevArrow: settings.prevButton,
        slidesToScroll: 1,
        slidesToShow: 1,
        touchThreshold: 4,
        accessibility: true,
        variableWidth: false,
      });

      $previewTrack.slick(thumbnail_options);
      methods.modifyGrid($context);

      $context.find(settings.itemClass).length < 2 ? $context.addClass(settings.singleClass) : $context.removeClass(settings.singleClass);

      $mainTrack.on('init', function(event, slick, currentSlide){

       var urlParams = new URLSearchParams(window.location.search);
       if( urlParams.has('feature')) {

        let _contentIdentifier = urlParams.get('feature');
         settings.currentSlideNum = parseInt($('[data-content-identifier="' + _contentIdentifier + '"]').not('.slick-cloned').attr('data-slick-index')) + 1;
       }

        $mainTrack.slick('slickGoTo', settings.currentSlideNum);

        // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var tag_info = i + ' of ' + slick.slideCount;;
        methods.setCaption(i);
        $tag.html(tag_info);
      });

      $previewTrack.on('beforeChange', function(event, slick, currentSlide, nextSlide){

        if(inGridMode) {
          event.preventDefault();
          event.stopPropagation();
        }

      });

      $previewTrack.on('afterChange', function(event, slick, currentSlide){

        $('.slick-slide img').attr('aria-hidden', 'true');
        $('.slick-slide[data-slick-index="' + currentSlide + '"] img').attr('aria-hidden', 'false');

        if(inGridMode) {
          event.preventDefault();
          event.stopPropagation();
        }

      });

      $mainTrack.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            event.preventDefault();
            event.stopPropagation();

        if(inGridMode) {
          var _sameEvent = methods.isSameEvent(event);
          if (0 != _sameEvent) {

            // determine slide direction
            if (currentSlide != nextSlide) {
              var _decl = currentSlide - nextSlide;
              if(_decl == 1 || _decl == (slick.slideCount-1)*(-1) ) {
                slideDirection = SLIDE_DIRECTION.PREVIOUS;
              } else {
                slideDirection = SLIDE_DIRECTION.NEXT;
              }

              if(currentSlide == (slick.slideCount - 1)){
                resetAd = true;
              }

             }
           }
          }
      });

      $mainTrack.on('init reInit afterChange', function(event, slick, currentSlide){
      
          var _sameEvent = methods.isSameEvent(event);
          if (0 != _sameEvent) {

            $('.slick-slide img').attr('aria-hidden', 'true');
            $('.slick-slide[data-slick-index="' + currentSlide + '"] img').attr('aria-hidden', 'false');

            // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            var tag_info = i + ' of ' + slick.slideCount;
            methods.setCaption(i);
            $tag.html(tag_info);
            methods.setOgMeta();
          
          if(inGridMode) {
            resetAd = true;
            //$('.gallery--expand .share-menu').fadeOut();
            // Ad feature not ready
            //methods.insertAd(event, slick, currentSlide, true);
          }
        }
     });

      // Set slide to currentSlideNum + 1 - Because it is zero based.
      methods.setCaption(settings.currentSlideNum + 1);
      }

    methods.initGrid = function($context) {

      // modify markup for grid layout
      if( $context.find(settings.gridClass).length ) {

        var $current = 0;
        $context.find(settings.gridClass).find('.gallery__thumbnail-crop').each( function() {
            $(this).addClass('slick-slide  slick-active slick-current');
            $(this).attr('data-slick-index', $current); $current++;
         }
        );
        $context.find('.gallery__thumbnail.slick-slide.slick-cloned').remove();

        methods.modifyGrid($context);
      }
    }

    methods.modifyGrid = function($context) {
      if (inGridMode) {
        $context.find('.gallery__thumbnail.slick-slide.slick-cloned').remove();
        $context.find('.gallery__thumbnail.slick-slide').removeAttr('style');
        $context.find('.slick-track').find('img').each( function(){ var $image = $(this); $image.attr({src: $image.attr('data-lazy'),}).removeAttr('data-lazy')});

        var urlParams = new URLSearchParams(window.location.search);
        if( urlParams.has('feature')) {

         let _contentIdentifier = urlParams.get('feature');
         let _currentSlideNum = parseInt($('[data-content-identifier="' + _contentIdentifier + '"]').not('.slick-cloned').attr('data-slick-index')) + 1;
         settings.currentSlideNum = isNaN(_currentSlideNum) ? 0 : _currentSlideNum;
        }

      }
    }

    methods.insertAd = function(event, slick, currentSlide, directionChanged) {
      if(inGridMode) {

        sameEvent = event.timeStamp - timeStampLast;
        if (0 != sameEvent) {
          var adIndex = $sliderItem.siblings(settings.itemAdId) ? $sliderItem.siblings(settings.itemAdId).index() : '';

           let _showAd = currentSlide % 3;

          if( 0 < currentSlide && 0 == _showAd && parseInt(initialTargetIndex) != currentSlide){
            if (-1 == adIndex || (-1 != adIndex && resetAd) || (-1 != adIndex && directionChanged)) {
              var _currentIndex = $mainTrack.slick("slickCurrentSlide");

              //determine click/swipe direction to know where to add the ad -/+
              var _direction = (slideDirection) ? slideDirection : 1;
              var _offset = 5 * _direction;

              var _adOffsetIdx = parseInt(_currentIndex) + _offset;
              var _slideCount = slick.slideCount;

              if (_currentIndex > _slideCount) {
                _adOffsetIdx = _currentIndex;
              } else if (0 > _currentIndex ) {
                _adOffsetIdx = 0;
              }

              let _targetIndex  = 1 + _adOffsetIdx;

              if( 0 == _showAd ){

                $('#slider-ad').css({ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, background: "rgba(0,0,0,0.8)" }).appendTo($('.gallery__item.slick-slide.slick-current.slick-active')).animate({ opacity: 1 });

                var googletag = googletag || {};
                googletag.cmd = googletag.cmd || [];

                googletag.cmd.push(function() {
                  googletag.pubads().refresh();
                });
              }

              $('#slider-ad').delay(10000).animate({ opacity: 0 }, 600);

              resetAd = false;
              timeStampLast = event.timeStamp;
              //$mainTrack.slick('slickGoTo', currentSlide -1);
              $mainTrack.slick('slickGoTo', currentSlide);
            }
          }
        }
          slickTrackLeft = $('.slick-track').position().left;
          prevSlideIdx = currentSlide;
      }
    }

    methods.isAd = function(event) {
      var _sameEvent = methods.isSameEvent(event);
      if (0 != _sameEvent) {
        var _adLeft =  ($('#slider-ad').length > 0 && $('#slider-ad').position().left > 0) ? $('#slider-ad').position().left : Number.MIN_VALUE;
        var _slickTrackLeft = $('.slick-track').position().left;
        var _isAd = (Math.abs(_slickTrackLeft) - Math.abs(_adLeft)) == 0 ? true : false;
        return _isAd;
      }
    }

    methods.isSameEvent = function(event) {
      sameEvent = event.timeStamp - (timeStampLast ? timeStampLast : 0);
      return sameEvent;
    }

    methods.initContext = function($context) {
      $window = $(window);
      $mainTrack = $context.find(settings.mainTrack);
      $previewTrack = $context.find(settings.previewTrack);
      $tag = $context.find(settings.tag);
      $caption = $context.find(settings.caption);
      $expandButton = $context.find(settings.expandButton);
      $closeButton = $context.find(settings.closeButton);
      $nextButton = $context.find(settings.nextButton);
      $prevButton = $context.find(settings.prevButton);
      $sliderItem = $context.find(settings.itemClass);
      $sliderAd = $context.find(settings.itemAdId);
      $galleryThumbnail = $context.find(settings.galleryThumbnail);

      $expandButton.off('click.lmGallery').on('click.lmGallery', function() {
        settings.currentSlideNum = $mainTrack.slick("slickCurrentSlide");
        $context.addClass('gallery--expand');
        inExpandMode = true;
        methods.restartSlick($context);
        methods.modifyGrid($context);
      });

      $galleryThumbnail.off('click.lmGallery').on('click.lmGallery', function() {

        if(inGridMode) {
            settings.currentSlideNum = parseInt($(this).attr('data-slick-index'));
            initialTargetIndex = settings.currentSlideNum;
          if(!inExpandMode) {
            $context.addClass('gallery--expand');
            inExpandMode = true;
            $context.find('.gallery__track').find('.slick-track').removeAttr('style');
            //methods.restartSlick($context)
            //methods.modifyGrid($context);
          }
          methods.restartSlick($context)
            methods.modifyGrid($context)
        }
      });

      $closeButton.off('click.lmGallery').on('click.lmGallery', function() {
        settings.currentSlideNum = $mainTrack.slick("slickCurrentSlide");
        $context.removeClass('gallery--expand');
        $('.trevda').show();
        inExpandMode = false;
        initialTargetIndex = settings.currentSlideNum;
        methods.restartSlick($context);
        $mainTrack.slick('slickGoTo', initialTargetIndex);
      });

      $window.off('resize.lmGallery').on('resize.lmGallery', function(){
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function(){

          if(inGridMode) {
            $context.find('.gallery__thumbnail.slick-slide.slick-cloned').remove();
            methods.restartSlick($context)
            methods.modifyGrid($context);
          } else {
            methods.initSlick($context);
            methods.modifyGrid($context);
          }
        }, 250);
      });

      $nextButton.off('click.lmGallery').on('click.lmGallery', function(event) {
        event.preventDefault();

        //$mainTrack.slick('slickSetOption', 'initialSlide', 9, true);
        event.stopPropagation();
      });

      methods.initSlick($context);
      methods.modifyGrid($context);

      // shared
              clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function(){

       var urlParamString = window.location.search;
       var urlParams = new URLSearchParams(urlParamString);

       if( urlParams.has('feature')) {

        let _contentIdentifier = urlParams.get('feature');
        let _currentSlideNum  = parseInt($('[data-content-identifier="' + _contentIdentifier + '"]').not('.slick-cloned').attr('data-slick-index'));
        console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
        console.log('_currentSlideNum: ' + _currentSlideNum + ' <> currentSlideNum: ' + settings.currentSlideNum);

        //_currentSlideNum = isNaN(_currentSlideNum) ? 0 : _currentSlideNum - 1;
        _currentSlideNum = isNaN(_currentSlideNum) ? 0 : _currentSlideNum;

        settings.currentSlideNum = _currentSlideNum;
        $mainTrack.slick('slickGoTo', settings.currentSlideNum);

        console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
        console.log('_currentSlideNum: ' + _currentSlideNum + '<> currentSlideNum: ' + settings.currentSlideNum);
       }

        }, 300);

       //shared end

      settings.document.keydown(function(event) {
        if (event.keyCode == 27) {
          if(inExpandMode) {
            $closeButton.trigger('click.lmGallery');
          }
        }
      });
    }

    // Filter each function
    methods.filterEach = function() {
      return !$(this).data("initialized");
    }

    // Methods to run inside loop
    return this.filter(methods.filterEach).each(function() {
      var $this = $(this);
      // NOTE: Method you'd like initialized on a per context basis
      methods.initContext($this);
    });
  };
}(jQuery));